<div class="logo {{size}} {{noText ? 'no-text' : ''}}"></div>
